export { default } from './SearchedHits';
